import { useState } from "react";
import { Check, Copy, ExternalLink, KeyRound } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AMBER = "#e69d27";

const STEPS = [
  ["Get a Gen Alpha licence", "€99 one-time, in Pricing below. Your key arrives by email instantly."],
  ["Create a fal.ai account", <>Sign up at <a href="https://fal.ai" target="_blank" rel="noreferrer" className="underline" style={{ color: AMBER }}>fal.ai</a> and add a little credit under Billing. Matting is billed by fal.ai to you, roughly €0.10–0.50 per second of footage.</>],
  ["Create your fal.ai API key", <>Open <a href="https://fal.ai/dashboard/keys" target="_blank" rel="noreferrer" className="underline" style={{ color: AMBER }}>fal.ai/dashboard/keys</a>, click "Add key", choose the FULL preset (so the plugin can also show what each matte really cost) and copy it.</>],
  ["Paste three things in the panel", "In the Gen Alpha panel in Resolve: the Backend URL below, your licence key and your fal.ai API key. Both keys are remembered on that computer only, never inside your project."],
];

function CopyUrl() {
  const [ok, setOk] = useState(false);
  return (
    <div className="flex items-center gap-2 bg-black border border-[#2a2f3d] px-3 py-2" data-testid="genalpha-backend-url">
      <span className="font-mono text-[10px] uppercase tracking-widest text-[#5c6479]">Backend URL</span>
      <code className="font-mono text-sm break-all flex-1" style={{ color: AMBER }}>{BACKEND_URL}</code>
      <button onClick={() => { navigator.clipboard?.writeText(BACKEND_URL); setOk(true); }} className="btn-ghost px-2 py-1 text-xs flex items-center gap-1" data-testid="genalpha-backend-url-copy">
        {ok ? <Check size={12} /> : <Copy size={12} />}{ok ? "copied" : "copy"}
      </button>
    </div>
  );
}

export const GenAlphaGuide = () => (
  <section className="card p-6 space-y-5" data-testid="genalpha-byok-guide">
    <div className="flex items-center gap-3 flex-wrap">
      <KeyRound size={18} style={{ color: AMBER }} />
      <h3 className="font-display uppercase text-2xl">Bring your own fal.ai key</h3>
      <span className="chip ml-auto" style={{ color: AMBER, borderColor: AMBER }}>no monthly plan · pay fal.ai only for what you matte</span>
    </div>
    <ol className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {STEPS.map(([t, body], i) => (
        <li key={t} className="bg-[#0e1013] border border-[#2a2f3d] p-4 space-y-1" data-testid={`genalpha-step-${i + 1}`}>
          <div className="font-mono text-[11px] uppercase tracking-widest" style={{ color: AMBER }}>step {i + 1}</div>
          <div className="font-semibold">{t}</div>
          <p className="text-sm text-[#9ba3b4]">{body}</p>
        </li>
      ))}
    </ol>
    <CopyUrl />
    <p className="text-xs text-[#5c6479] flex items-center gap-1"><ExternalLink size={12} /> Your fal.ai key is only used to run your own matting jobs and is never stored on our servers.</p>
  </section>
);
